export default __webpack_public_path__ + "assets/images/button-normal.9c7176126ab8eeba914f81ea245a4900.svg";